import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgSealPercent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 6.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m4 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M15 8c0 .652-.47 1.142-.884 1.574-.235.246-.48.5-.571.723-.085.204-.09.543-.095.871-.01.61-.02 1.301-.5 1.782-.48.48-1.172.49-1.782.5-.328.005-.667.01-.871.095-.223.092-.477.336-.723.571C9.142 14.531 8.653 15 8 15c-.652 0-1.142-.47-1.574-.884-.246-.235-.5-.48-.723-.571-.204-.085-.543-.09-.871-.095-.61-.01-1.301-.02-1.782-.5-.48-.48-.49-1.172-.5-1.782-.005-.328-.01-.667-.095-.871-.092-.223-.336-.477-.571-.723C1.469 9.142 1 8.653 1 8c0-.652.47-1.142.884-1.574.235-.246.48-.5.571-.723.085-.204.09-.543.095-.871.01-.61.02-1.301.5-1.782.48-.48 1.172-.49 1.782-.5.328-.005.667-.01.871-.095.223-.092.477-.336.723-.571C6.858 1.469 7.348 1 8 1s1.142.47 1.574.884c.246.235.5.48.723.571.204.085.543.09.871.095.61.01 1.301.02 1.782.5.48.48.49 1.172.5 1.782.005.328.01.667.095.871.092.223.336.477.571.723.415.432.884.922.884 1.574m-9-.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4.854-1.646a.5.5 0 0 0-.708-.708l-5 5a.501.501 0 0 0 .708.708zM11.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSealPercent);
export default ForwardRef;
